export default __webpack_public_path__ + "static/media/mercedes_offer1.9ad89ddb.jpg";